import React from 'react'
import Search from './Search'
import SetupPage from 'modules/setup/SetupPage'
import ProteccionInfoTab from './proteccionInfo/ProteccionInfoTab'
import { faSquare } from '@fortawesome/free-solid-svg-icons'

const ProteccionSetup = () => {

	const setupProps = {
		title: "Proteccions",
		icon: faSquare,
		addNewTitle: "Crear proteccion",
		searchUrl: "/proteccionSetup/search",
		rowKey: "idProteccion",
		columns: [
			{ key: "idProteccion", name: "ID", sortable: true, width: 60 },
			{ key: "nombre", name: "Nombre", sortable: true },
		],
		tabs: [
			{ key: "info", title: "Info", comp: ProteccionInfoTab }
		]
	};

	return (
		<SetupPage
			setupProps={setupProps}
			search={Search} />
	)
}

export default ProteccionSetup;